import * as React from 'react';


export default class UploadDefault extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 62">
                <defs>
                    <path id="a" d="M48.941 11.596v45.816a2.824 2.824 0 0 1-2.823 2.823H2.824A2.824 2.824 0 0 1 0 57.412V2.824A2.824 2.824 0 0 1 2.824 0h34.522a3 3 0 0 1 2.12.879l8.596 8.595a3 3 0 0 1 .88 2.122z"/>
                </defs>
                
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(.53 .882)">
                        <use fill="#FFF" xlinkHref="#a"/>
                        <path stroke="#E4E4E4" strokeWidth="2" d="M47.941 11.596a2 2 0 0 0-.586-1.415L38.76 1.586A2 2 0 0 0 37.346 1H2.824A1.824 1.824 0 0 0 1 2.824v54.588c0 1.007.816 1.823 1.824 1.823h43.294a1.824 1.824 0 0 0 1.823-1.823V11.596z"/>
                    </g>
                    <path fill="#E0E0E0" d="M6.176 17.823h37.647v4.706H6.176zM6.176 7.47H32.53v4.706H6.176zM6.176 28.176h37.647v4.706H6.176zM6.176 38.53h37.647v4.705H6.176zM6.176 48.882h37.647v4.706H6.176z" opacity=".5"/>
                    <path fill="#727272" d="M36.884 5.728v6.89a.5.5 0 0 0 .5.5h6.889a.5.5 0 0 0 .354-.854l-6.89-6.89a.5.5 0 0 0-.853.354z"/>
                </g>
            </svg>
        )
    }
}
